module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/changing-room-23b46eb465d08c2838846efe9288f89f.png";